import React from 'react';
import PropTypes from 'prop-types';

import { Link } from '@ontruck/orc';

const HandledByCell = ({ handledByName, handleClick, className }) => (
  <Link className={className} onClick={handleClick} text={handledByName} weight="bold" />
);

HandledByCell.propTypes = {
  handledByName: PropTypes.func,
  handleClick: PropTypes.func,
  className: PropTypes.string,
};

export default HandledByCell;
